export default "__VITE_ASSET__BP7Nnh7W__"